module.exports = __webpack_public_path__ + "img/726.602305c8.jpg";